import styled from 'styled-components';

export const ContainerMain = styled.div.attrs({ className: 'container main' })``;
